import React, { useEffect, useRef, useState } from "react";
import Fileupload from "../../components/Fileupload";
import { useParams } from "react-router-dom";
import {
  csv_to_json,
  getlanguagetagdata,
  send_language_tag,
} from "../../api/api";
import { toast } from "react-toastify";

const Languagetag = ({ fileId, renderpage }) => {
  const [file, setFile] = useState(null);
  const [apiData, setApiData] = useState([]);
  const [filterToggle, setFilterToggle] = useState(false);
  const [filters, setFilters] = useState([]);
  const [selecteddata, setSelectedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [downloadTriggered, setDownloadTriggered] = useState(false);
  const [csvFileURL, setCSVFileURL] = useState(null);
  const [csvFileName, setCSVFileName] = useState(null);
  const [loading, setLoading] = useState(false);
  const filterref = useRef();
  const [stage, setStage] = useState();

  // const filters = ["en", "es", "nl"];

  const { category } = useParams();

  console.log(category);

  useEffect(() => {
    const handlefiltertoggle = (event) => {
      if (
        filterref.current &&
        !filterref.current.contains(event.target) &&
        !event.target.closest(".filterbtn")
      ) {
        setFilterToggle(false);
      }
    };

    document.addEventListener("mousedown", handlefiltertoggle);

    return () => {
      document.removeEventListener("mousedown", handlefiltertoggle);
    };
  });

  useEffect(() => {
    fetchdata(fileId);
  }, [fileId]);

  const fetchdata = async (currentFileId) => {
    setLoading(true);
    try {
      let data = await getlanguagetagdata(currentFileId, category);
      if (data.data) {
        console.log(data.data);
        setLoading(false);
        setApiData(data.data.other_lang);
        setFilters(data.data.lang);
        setStage({
          previous: data.data.previous_process,
          next: data.data.next_process,
        });
        if (data.data.content) {
          decodeCSV(data.data.content);
        }
        setCSVFileName(data.data.file_name);
      } else {
        // alert(data.error.message);
        toast.error(data.error.message);
        setLoading(false);
      }
    } catch (e) {
      alert(e);
      setLoading(false);
    }
  };

  // console.log(apiData);

  const convertCSVToJSON = async (csvFileName, file) => {
    try {
      let response = await csv_to_json(csvFileName, file);
      if (response.data) {
        fetchdata(fileId);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (file?.length > 0) {
      convertCSVToJSON(csvFileName, file);
    }
  }, [file, csvFileName]);

  // console.log(csvFileName);

  const decodeCSV = (data) => {
    try {
      const file = data;
      const byteCharacters = atob(file);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      // console.log(byteArrays);
      const blob = new Blob(byteArrays, { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      setCSVFileURL(url);
    } catch (e) {
      // console.log(e);
      toast.error(e);
    }
  };

  useEffect(() => {
    if (selectedFilter.length === 0) {
      setFilteredData(apiData);
    } else {
      setFilteredData(
        apiData.filter((items) =>
          selectedFilter.some((filter) => items.lang_code.includes(filter))
        )
      );
    }
  }, [selectedFilter, apiData]);

  const handleClick = (i, item) => {
    setSelectedData([]);
    setSelectedFilter((prev) =>
      prev?.includes(item)
        ? prev.filter((items) => items !== item)
        : [...prev, item]
    );
  };

  const handleSelect = (e) => {
    console.log(e.target.value);
    setSelectedData((prev) =>
      prev.includes(filteredData[e.target.value])
        ? prev.filter((item) => item !== filteredData[e.target.value])
        : [...prev, filteredData[e.target.value]]
    );
  };

  console.log(selecteddata);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedData([...filteredData]);
    } else {
      setSelectedData([]);
    }
  };

  console.log(stage);

  const senddata = async (event) => {
    const button = event.currentTarget;
    button.disabled = true; // Disable the button
    document.body.style.cursor = "wait";
    try {
      if (apiData.length > 0) {
        if (selecteddata.length > 0) {
          button.disabled = true;
          document.body.style.cursor = "wait";
          let response = await send_language_tag(
            fileId,
            selecteddata,
            category
          );
          if (response.data) {
            document.body.style.cursor = "default";
            handleNext(fileId, stage.next);
          } else {
            // alert(response.error.message);
            toast.error(response.error.message);
            button.disabled = false;
            document.body.style.cursor = "default";
          }
        } else {
          // alert("Select atleast one language to proceed");
          toast.warn("Select atleast one language to proceed");
          button.disabled = false;
          document.body.style.cursor = "default";
        }
      } else {
        event.currentTarget.disabled = true;
        document.body.style.cursor = "wait";
        let response = await send_language_tag(fileId, selecteddata, category);
        if (response.data) {
          document.body.style.cursor = "default";
          handleNext(fileId, stage.next);
        } else {
          // alert(response.error.message);
          toast.error(response.error.message);
          button.disabled = false;
          document.body.style.cursor = "default";
        }
      }
    } catch (e) {
      // console.log(e);
      toast.error(e);
      document.body.style.cursor = "default";
      button.disabled = false;
    }
  };

  const handleNext = (fileId, nextpage) => {
    renderpage(fileId, nextpage);
  };

  const handleDownload = () => {
    if (csvFileURL) {
      setDownloadTriggered(true);
      const link = document.createElement("a");
      link.href = csvFileURL;
      link.download = "CSV_file.csv"; // You can specify the name of the file here
      link.click();
      toast.success("Template downloaded");
      // Clean up the URL object
      window.URL.revokeObjectURL(csvFileURL);
    } else {
      // alert("No File to Download");
      toast.info("No File to Download");
    }
  };

  // const convertJSONToCSV = (apiData) => {
  //   const keys =
  // }

  // console.log(file);

  return (
    <div className="flex flex-col w-full">
      <div className="p-8 flex flex-col gap-8 h-[100%] min-h-[70vh]">
        <div className="flex w-full justify-between text-left items-center">
          <div className="flex items-center gap-8 relative">
            <h1 className="text-24 font-semibold">Language Tag</h1>
            <span className="flex gap-4">
              <div
                className={`filterbtn flex gap-2 px-3 py-3 border-[1.5px] border-commonborder rounded-[12px] cursor-pointer`}
                onClick={() => setFilterToggle(!filterToggle)}
              >
                <img
                  src={process.env.PUBLIC_URL + "/images/adjust.svg"}
                  alt="editor_logo"
                ></img>
                <p className={`text-14 font-semibold `}>
                  {selectedFilter.length > 0
                    ? "Filters Applied"
                    : "Apply Filters"}
                </p>
              </div>
              {filterToggle && (
                <span
                  ref={filterref}
                  className="absolute max-h-[300px] max-w-[500px] min-w-[300px] bg-white top-[120%] rounded-[16px] z-20 shadow-loginshadow"
                >
                  <div className="flex justify-between px-4 py-6 border-b-[1px] border-commonborder">
                    <p>Language Code</p>
                    <div className="hover:border-[1px] border-commonborder cursor-pointer">
                      <img
                        onClick={() => setFilterToggle(false)}
                        src={process.env.PUBLIC_URL + "/images/cross.png"}
                        alt="close_btn"
                      />
                    </div>
                  </div>
                  <div className="max-h-[200px] overflow-auto flex px-4 py-6 gap-3 flex-wrap overflow-auto">
                    {filters
                      ? filters.map((item, i) => (
                          <button
                            key={i}
                            onClick={() => handleClick(i, item)}
                            className={`${
                              selectedFilter.includes(item)
                                ? "bg-highlight text-white"
                                : "bg-filterbg text-title"
                            } px-4 py-2 rounded-[8px]`}
                          >
                            {item}
                          </button>
                        ))
                      : "No data to filter"}
                  </div>
                </span>
              )}
              {/* <button className="flex gap-2 px-3 py-3 border-[1.5px] border-commonborder rounded-[12px]">
                <img
                  src={process.env.PUBLIC_URL + "/images/close.svg"}
                  alt="editor_logo"
                ></img>
                <p className="text-title text-14 font-semibold">
                  Remove Unwanted
                </p>
              </button> */}
            </span>
          </div>
          <button
            onClick={() => handleDownload()}
            className="flex gap-2 px-3 py-3 border-[1.5px] border-highlighttext rounded-[12px] bg-white"
          >
            <img
              src={process.env.PUBLIC_URL + "/images/settings.svg"}
              alt="editor_logo"
            ></img>
            <p className="text-highlighttext text-14 font-semibold">
              Generate CSV File
            </p>
          </button>
        </div>
        <div className="flex gap-8">
          <div
            className={`${
              downloadTriggered ? "w-1/2" : "w-full"
            } overflow-auto rounded-[16px] border-[1px] border-commonborder flex h-fit max-h-[400px] shadow-commonshadow`}
          >
            <table className="w-full ">
              <thead className="sticky top-0 z-10 bg-tableheadingbg px-4 py-6 text-left text-white text-16 font-semibold sticky top-0">
                <tr className="">
                  <th
                    className="px-4 py-5 border-r-[1px] border-commonborder"
                    style={{ width: "5%" }}
                  >
                    <input
                      onChange={(e) => handleSelectAll(e)}
                      className="h-5 w-5 bg-tableheadingbg border-[1px] border-commonborder"
                      type="checkbox"
                      checked={selecteddata?.length === filteredData?.length}
                    />
                  </th>
                  <th className="px-4 py-5 border-r-[1px] border-commonborder">
                    Language
                  </th>
                  <th className="px-4 py-5">Code</th>
                </tr>
              </thead>
              <tbody className="w-full text-left bg-white h-fit overflow-auto">
                {filteredData && filteredData.length > 0 ? (
                  filteredData.map((items, i) => (
                    <tr
                      key={i}
                      className="border-b-[1px] border-commonborder last:border-none h-fit"
                    >
                      <td className="px-4 py-3 border-r-[1px] border-commonborder">
                        <input
                          onChange={(e) => handleSelect(e)}
                          value={i}
                          className="h-5 w-5"
                          type="checkbox"
                          checked={selecteddata?.includes(items)}
                        />
                      </td>
                      <td className="px-4 py-3 border-r-[1px] border-commonborder">
                        <p className="">
                          {items.text.length > 100
                            ? items.text.slice(0, 100) + "..."
                            : items.text}
                        </p>
                      </td>
                      <td className="px-4 py-3 border-r-[1px] border-commonborder">
                        <p className="">{items.lang_code}</p>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="border-b-[1px] border-commonborder last:border-none h-fit">
                    <td className="px-4 py-3 border-r-[1px] border-commonborder"></td>
                    {loading ? (
                      <>
                        <td className="px-4 py-3 border-r-[1px] border-commonborder">
                          <p className="">Loading data please wait .....</p>
                        </td>
                        <td className="px-4 py-3 border-r-[1px] border-commonborder">
                          <p className=""></p>
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="px-4 py-3 border-r-[1px] border-commonborder">
                          <p className="">No Data to Show</p>
                        </td>
                        <td className="px-4 py-3 border-r-[1px] border-commonborder">
                          <p className=""></p>
                        </td>
                      </>
                    )}
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {downloadTriggered && (
            <div className="w-1/2 shadow-commonshadow rounded-[24px]">
              <Fileupload file={file} setFiles={setFile} category={category} />
            </div>
          )}
        </div>
        <div className="flex ml-auto gap-5">
          <button
            disabled={loading}
            onClick={(event) => {
              handleNext(fileId, stage.previous);
            }}
            className="w-fit mt-20 flex "
          >
            <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
              PREV
            </p>
          </button>
          <button
            disabled={loading}
            onClick={(event) => {
              senddata(event);
            }}
            className="w-fit mt-20 flex"
          >
            <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
              NEXT
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Languagetag;
